import React from 'react';
import styled from 'styled-components';

import Modal from '~/atomic/molecula/Modal';
import { TextRegStyle } from '~/atomic/Typography';
import { activateCatalogTimerDiscountSelector } from '~/feature/withTiwerDiscount/activateCatalogTimerDiscount/activateCatalogTimerDiscount.selector';
import { useAppSelector } from '~/store';

export const ActivateCatalogTimerDiscountLoadingModal = () => {
  const { isShowActivateCatalogTimerDiscountLoadingModal } = useAppSelector(activateCatalogTimerDiscountSelector);

  return (
    <SCModal
      open={isShowActivateCatalogTimerDiscountLoadingModal}
      closable={false}
    >
      <SCMessage>
        Активируем скидки...
      </SCMessage>
    </SCModal>
  );
};

const SCMessage = styled.span`
  ${TextRegStyle};
  color: var(--black-color);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const SCModal = styled(Modal)`
  max-width: 300px;
  
  .ant-modal-body {
    height: 100px;
  }
`;
